import React from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import "./marketingEmailModal.scss";
const MarketingEmailModal = ({
  handleMarketingModal,
  showMarketingModal,
  handleBlur,
  handleInputChange,
  formDataMarketingEmail,
  marketingEmailError,
  activeTab,
  handleSignupCompany,
  handleSignupIndividual,
  isMarketingSubChecked,
  setMarketingSubChecked,
  handleMarketingSubCheckboxClick,
}) => {
  return (
    <div>
      {" "}
      <Modal
        // size="lg"
        className="marketing-email-container"
        // style={{width: "100%"}}
        show={showMarketingModal}
        centered
        onHide={handleMarketingModal}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="pt-0 mar-email-body">
          <h4> Following are the terms for marketing email </h4>
          <p>
          The marketing pro subscription is for established businesses that want to advertise their company or business on the Helpr platform. In order to receive a job through Helpr for the marketing pro subscription, you will need to provide a marketing email address that can be used to send the pre-filled customer contact information directly to your company or business. Your monthly or annual subscription fee will only allow you to advertise your business as a provider on the Helpr platform and will not provide any other support or services. If you would like to sign up with the full subscription, available to all providers to use for booking, invoicing, messaging and scheduling then please go back to the previous page.
          </p>
          <Form.Group className="mb-3 mt-4" controlId="marEmailCheck">
            <div className="d-flex w-100 align-items-center gap-2 form-check-wrapper">
              <Form.Check
                className="mb-0"
                type="checkbox"
                id="marEmailCheck"
                checked={isMarketingSubChecked}
                onClick={handleMarketingSubCheckboxClick}
              />
              <div>Same as personal email</div>
            </div>
            {/* {errorsNext1.contract && (
                        <span style={{ color: "red" }}>
                          {errorsNext1.contract}
                        </span>
                      )} */}
          </Form.Group>
          {!isMarketingSubChecked ? (
            <Form.Group className="mb-4 mt-2" controlId="marketingEmail">
              {/* <Form.Label>Email</Form.Label> */}
              <Form.Control
                type="text"
                autoComplete="off"
                name="marketingEmail"
                value={formDataMarketingEmail}
                onBlur={handleBlur}
                onChange={handleInputChange}
                placeholder="Enter your marketing email"
              />
              <span style={{ color: "red" }}>{marketingEmailError}</span>
            </Form.Group>
          ) : null}
          <Form.Group className="mb-3">
            <div className="d-grid">
              <Button
                type="submit"
                onClick={
                  activeTab === "tabcompany"
                    ? handleSignupCompany
                    : handleSignupIndividual
                }
                variant="primary"
                size="lg"
              >
                Marketing Provider Sign Up
              </Button>
            </div>
          </Form.Group>
          <Form.Group className="mt-3">
            <div className="d-grid">
              <Button
                // type="submit"
                onClick={handleMarketingModal}
                variant="primary"
                size="lg"
              >
                Cancel
              </Button>
            </div>
          </Form.Group>
          {/* <h5>Subscription Purpose:</h5>
          <p>
            The subscription concerns marketing emails directed towards service
            providers.
          </p>
          <h5>Offline Transactional Work:</h5>
          <p>
            All transactional and job-related activities are to be executed
            offline, ensuring a personalized approach.
          </p>
          <h5>Notification Process:</h5>
          <p>
            Job details will be disseminated through marketing emails once
            customers furnish the necessary job information.
          </p> */}

          {/* <p>This is for the service provider who wants to opt for marketing email subscription.</p>
          <p>All the transaction and job work will be done offline.</p>
          <p>Job details will be sent to your marketing email once customer provides details for the job.</p> */}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MarketingEmailModal;
